import { useEffect } from 'react';

import { useTheme } from 'styled-components';
import { debounce } from 'lodash-es';

import BaseTooltip, { TooltipProps } from '@components/ui/Tooltip/next';
import { useDevice } from '@contexts/device';

const Tooltip = ({
  children,
  hideTooltip,
  ...others
}: React.PropsWithChildren<
  Partial<TooltipProps> & { hideTooltip?: () => void }
>) => {
  const { palette } = useTheme();
  const { isDesktop } = useDevice();

  const scrollHandler = () => {
    hideTooltip?.();
  };

  useEffect(() => {
    window.addEventListener('scroll', debounce(scrollHandler, 200), {
      passive: true,
    });

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);
  return (
    <BaseTooltip
      overlayInnerStyle={{
        position: 'relative',
        borderRadius: 10,
        width: 'fit-content',
        backgroundColor: palette.darkGrey,
        fontSize: 14,
        color: palette.white,
        lineHeight: 1.43,
        textAlign: 'left',
        padding: '10px',
        whiteSpace: isDesktop ? 'nowrap' : 'unset',
        maxWidth: isDesktop ? '100vw' : '200px',
      }}
      {...others}
    >
      {children}
    </BaseTooltip>
  );
};

export default Tooltip;
